module.exports = __webpack_public_path__ + "assets/img/邮箱.347de950.png";